import $ from 'jquery';

export default () => {
      console.log('menu.js');
      var myOffcanvas = document.getElementById('offcanvasMenuMobile');
      var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);

      $(".cta-anchor").each(function (i, elem) {
            $(elem).on('click', function (e) {
                  e = e || window.event;
                  e.preventDefault();
                  e.stopPropagation();
                  var target = $(this).attr('data-href');
                  window.history.replaceState("", "", '/'+target);
                  if (target == "#contattaci") {
                        $(target).fadeIn();
                  }

                  if ($('.offcanvas.offcanvas-end.show').length > 0) {
                        console.log('close');
                        $('.offcanvas-header .text-reset').click();
                  }

                  $([document.documentElement, document.body]).animate({
                        scrollTop: $(target).offset().top
                  }, 500);
            });
      });
};



// WEBPACK FOOTER //
// ../views/partials/menu/menu.js